module.exports = __webpack_public_path__ + "img/13.a58ee324.png";